<template>
  <div>
    <ScriptShow ref="ScriptShow"></ScriptShow>
    <SelectServer ref="SelectServer" v-on:selectServerComplete="selectServerComplete"></SelectServer>
    <Modal
      v-model="execModal"
      :title="title"
      :mask-closable="false"
      @on-cancel="execModalCancel"
      width="500">
      <Form ref="execForm" :model="execForm" :label-width="100" :rules="execRule">
        <Alert v-show="execForm.default_certify" show-icon>使用目标服务器绑定的第一个凭证</Alert>
        <FormItem label="用户凭证">
          <Select v-model="execForm.certificate" :disabled="execForm.default_certify" placeholder="请选择目标服务器上存在的用户凭证">
            <Option v-for="item in allCertificateList" :value="item.id" :key="item.id">{{ item.name }}</Option>
          </Select>
        </FormItem>
        <FormItem label="默认凭证" prop="default_certify">
          <i-switch v-model="execForm.default_certify">
            <span slot="open">是</span>
            <span slot="close">否</span>
          </i-switch>
        </FormItem>
        <FormItem :label="'目标服务器(' + waitExecServerLength + ')'">
          <Button type="default" icon="ios-desktop-outline" @click="openSelectServerModal" v-if="!waitExecServerLength" class="w-100 align-left">选择目标服务器</Button>
          <a v-on:click="openSelectServerModal" v-else style="display:block;">继续选择 </a>
          <Tag color="primary" v-for="(value, key, index) in waitExecServer" :key="'wait_hostname_' + index" v-if="value">{{ key }}</Tag>
        </FormItem>
        <!--<FormItem label="脚本来源">-->
          <!--<RadioGroup>-->
            <!--<Radio label="manually">手工录入</Radio>-->
            <!--<Radio label="local">本地上传</Radio>-->
            <!--<Radio label="clone">脚本克隆</Radio>-->
          <!--</RadioGroup>-->
        <!--</FormItem>-->
        <FormItem label="脚本内容">
          <a v-on:click="openScriptView">预览脚本</a>
        </FormItem>
        <FormItem label="脚本参数">
          <Input placeholder="请输入脚本参数" :maxlength="512" v-model="execForm.params"/>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button type="primary" :loading="execIng" style="margin-right: 8px" @click="execOk">执行</Button>
        <Button @click="execModal = false">取消</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import { getOpsCenterAllCertificate, scriptExecApi } from '@/api/opscenter'
import ScriptShow from './script-show'
import SelectServer from './select-server'

export default {
  name: 'script-exec-modal',
  components: {
    ScriptShow,
    SelectServer
  },
  data () {
    return {
      scriptData: {},
      title: '脚本',
      execModal: false,
      execIng: false,
      allCertificateList: [],
      execForm: {
        default_certify: false,
        certificate: '',
        params: ''
      },
      execRule: {
      },
      waitExecServer: {},
      waitExecServerLength: 0
    }
  },
  methods: {
    // 打开执行Modal
    openModal (data) {
      this.title = '脚本名: ' + data.name + ' & 脚本类型: ' + data.type
      this.scriptData = data
      this.getAllCertificate()
      this.execModal = true
    },
    // 关闭执行Modal
    execModalCancel () {
      this.execForm.default_certify = false
      this.execForm.params = ''
      this.execForm.certificate = ''
      this.waitExecServer = {}
      this.waitExecServerLength = 0
    },
    // 打开预览脚本
    openScriptView () {
      this.$refs.ScriptShow.openModal(this.scriptData, false)
    },
    // 获取所有凭证列表
    getAllCertificate () {
      getOpsCenterAllCertificate().then(res => {
        this.allCertificateList = res.data
      })
    },
    // 打开服务器选择Modal
    openSelectServerModal () {
      this.$refs.SelectServer.openSelectServerModal({}, this.waitExecServer)
    },
    // 选择服务器完成回调
    selectServerComplete (server, length) {
      this.waitExecServer = server
      this.waitExecServerLength = length
    },
    // 开始执行脚本
    execOk () {
      this.$refs['execForm'].validate((valid) => {
        if (valid) {
          let serverIds = []
          for (let i in this.waitExecServer) {
            if (this.waitExecServer[i]) {
              serverIds.push(this.waitExecServer[i])
            }
          }
          let reqData = {
            id: this.scriptData.id,
            server_id: serverIds,
            certificate: this.execForm.certificate,
            default_certify: this.execForm.default_certify,
            params: this.execForm.params
          }
          this.execIng = true
          scriptExecApi(reqData).then(res => {
            let result = res.data
            this.execIng = false
            if (result.code === 200) {
              this.execModal = false
              this.$emit('execComplete')
              this.$Notice.success({
                title: '操作成功！',
                desc: result.data
              })
            } else {
              this.$Notice.error({
                title: result.msg
              })
            }
          }).catch(res => {
            this.execIng = false
            if (res.request) {
              this.$Notice.error({
                title: '操作失败！请求状态码:' + res.request.status,
                desc: res.request.responseText
              })
            } else {
              this.$Notice.error({
                title: '操作失败！'
              })
            }
          })
        }
      })
    }
  }
}
</script>
